"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    validateHotelDetailsURL: ()=>validateHotelDetailsURL
});
const analytics_js_namespaceObject = require("../analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
async function validateHotelDetailsURL(url) {
    try {
        const response = await fetch(url, {
            method: 'HEAD'
        });
        if (200 === response.status) return url;
        throw Error(`status code: ${response.status}`);
    } catch (e) {
        analytics_js_default().logError({
            loggedFrom: 'locationMetadataLinkClickHandler:validateHotelDetailsURL',
            message: 'invalid hotel details URL',
            url,
            error: e.message
        });
    }
    return '';
}
exports.validateHotelDetailsURL = __webpack_exports__.validateHotelDetailsURL;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "validateHotelDetailsURL"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
